module.exports = __webpack_public_path__ + "static/media/semi_sesamo.8ddca441.svg";